import React, { useState, useEffect } from 'react';
import '../css/common.css';

function ScrollTopButton() {
  const [show, setShow] = useState(true);

  useEffect(() => {
  setShow(true);
  }, []);
  
    // const onScroll = () => {
    //   setShow(window.scrollY > 200);
    // };

  //   window.addEventListener('scroll', onScroll);
  //   return () => window.removeEventListener('scroll', onScroll);
  // }, []);

  const goToContact = (e) => {
    e.preventDefault();
    window.location.href = 'tel:1533-5921'; 
  };

  const goToBlog = (e) => {
    e.preventDefault();
     window.open('https://blog.naver.com/PostList.naver?blogId=bc1592&tab=1', '_blank'); // 새 창에서 열기
  };

  const scrollToTop = (e) => {
    e.preventDefault();  // a 태그 기본 이동 막기
    window.scrollTo({ top: 0, behavior: 'smooth' });
    console.log(window.scrollY);
  };

  if (!show) return null;

  return (
    <div className="topbtbx">
      <a
        href="#"
        className="blogbt"
       onClick={goToBlog}
      >
        <p>
          Blog<br />
          <span>바로가기</span>
        </p>
      </a>

      <a href="#" className="callbt"  onClick={goToContact}>
        <p>
          24시<br />
          <span>상담전화</span>
        </p>
      </a>

      <a href="#" className="topbt" onClick={scrollToTop}>
        <p>
          ︿<br />
          TOP
        </p>
      </a>
    </div>
  );
}

export default ScrollTopButton;